export const REPORT_PAGE_LAYOUT = {
  widthPx: 816,
  heightPx: 1056,
  marginTopPx: 48,
  marginBottomPx: 44,
  marginHorizontalPx: 48,
} as const;

export const REPORT_FONT_FAMILY = "'Times New Roman', Times, serif";

// The hidden measurement pass and the visible PDF page must share this exact
// formatting context. In particular, flex-column prevents child margins from
// collapsing during measurement but not during final rendering.
export const REPORT_PAGE_FLOW_STYLE = {
  display: "flex",
  flexDirection: "column",
  fontFamily: REPORT_FONT_FAMILY,
  fontSize: 12,
  lineHeight: 1.5,
} as const;

export const REPORT_PRINT_PAGE_STYLES = `
  @page {
    margin: 0;
    size: letter;
  }

  .pdf-page {
    width: 8.5in !important;
    height: 11in !important;
    overflow: hidden !important;
    box-shadow: none !important;
    border: none !important;
    margin: 0 auto !important;
    background: #fff !important;
    box-sizing: border-box !important;
    break-after: page;
    page-break-after: always;
  }

  .pdf-page:last-child {
    break-after: auto;
    page-break-after: auto;
  }
`;
